import { toast } from 'react-toastify';
import * as config from '../lib/config';
import { fetchProject } from '../components/project-setup/actions';
import { fetchTenantById, fetchProjects } from '../components/projects/actions';
import Auth from '../auth/auth';

export const sendCommand = (cmd, commandLabel, successCallback) => {
  return (dispatch) => {
    let toastId = null;
    let toastNotify = () =>
      (toastId = toast(`${commandLabel.start || 'Sending command'}...`, {
        autoClose: false,
      }));

    toastNotify();

    const sendCommandStart = (cmd) => ({
      type: 'SEND_COMMAND_START',
      payload: cmd,
    });

    const sendCommandSuccess = (res) => ({
      type: 'SEND_COMMAND_SUCCESS',
      payload: res,
    });

    const sendCommandFailure = (error) => ({
      type: 'SEND_COMMAND_FAILURE',
      payload: error,
    });

    function handleSendCommandError(res, toastId) {
      if (!res.ok) {
        if (toastId) {
          toast.update(toastId, {
            render:
              commandLabel.fail ||
              commandLabel.start ||
              `Failed to send command`,
            type: toast.TYPE.ERROR,
            autoClose: 3000,
          });
        }
        const error = {
          code: res.status,
          error: new Error(
            commandLabel.fail || commandLabel.start || 'Failed to send command',
          ),
        };
        throw error;
      }
      return res;
    }

    dispatch(sendCommandStart(cmd));
    new Auth().checkAuth();
    return fetch(`${config.baseURL()}/api/commands`, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(cmd),
    })
      .then((res) => handleSendCommandError(res, toastId))
      .then((res) => {
        const updateToast = {
          toastId,
          message: commandLabel.success || commandLabel.start || 'Sent command',
          type: 'SUCCESS',
        };
        dispatch(sendCommandSuccess(res));

        if (cmd.projectId) {
          successCallback
            ? dispatch(
                successCallback(cmd.tenantId, cmd.projectId, updateToast),
              )
            : dispatch(fetchProject(cmd.tenantId, cmd.projectId, updateToast));
        } else {
          dispatch(fetchTenantById(cmd.tenantId, updateToast));
          dispatch(fetchProjects(cmd.tenantId, updateToast));
          toast.update(toastId, {
            render: commandLabel.success || 'Sent',
            type: toast.TYPE.SUCCESS,
            autoClose: 3000,
          });
        }
      })
      .catch((error) => {
        dispatch(sendCommandFailure(error));
      });
  };
};
